import { multisetCharsForScramble } from "./scrambleTextStyle";

/**
 * .scramble 링크 마우스오버 시 ScrambleText
 */
export class HomeScrambleLinks {
    static init(): void {
        const $ = (window as unknown as { $?: (s: string) => JQuery }).$;
        const gsap = window.gsap;
        if (!$ || !gsap) return;

        $(".scramble").each(function (this: HTMLElement) {
            const $el = $(this);
            const text = $el.text().replace(/\s+/g, " ").trim();
            const chars = multisetCharsForScramble(text);
            $el.on("mouseenter", function () {
                gsap.to($(this), {
                    scrambleText: {
                        text,
                        chars,
                        speed: 0.42,
                        revealDelay: 0.06,
                    },
                    duration: 0.72,
                    ease: "power2.out",
                });
            });
        });
    }
}

/* minimal jQuery typing for bundle */
interface JQuery {
    each(fn: (this: HTMLElement) => void): JQuery;
    on(
        ev: string,
        fn: (this: HTMLElement, e: unknown) => void,
    ): JQuery;
    text(): string;
}
